export enum Living {
  l500 = "l500",
  l1000 = "l1000",
  l2000 = "l2000",
  l3000 = "l3000",
  l6000 = "l6000",
  all = "all",
}

export enum Education {
  none = "none",
  brevet = "brevet",
  cap = "cap",
  bac = "bac",
  higher = "higher",
  all = "all",
}

export enum SocialCategory {
  farmer = "farmer",
  executive = "executive",
  intermediate = "intermediate",
  employee = "employee",
  worker = "worker",
  all = "all",
}

export interface ReferenceSelection<T> {
  ref: T;
  secondary: T;
}

export enum EvmcType {
  LIVING = "living",
  EDUCATION = "education",
  CATEGORY = "category",
}
